// Static legal documents — content provided by the product owner.
// Markdown-ish strings are rendered as React JSX (no markdown parser dep).

export const LEGAL_VERSION = "v1.4 — Févr. 2026";

export const SITE_URL = "https://www.myswimminglessons.fr";

export const CGU_TEXT = `1. Objet

Les présentes CGU régissent l'utilisation de l'application MySwimmingLessons, plateforme de mise en relation entre des clients et des Maîtres-Nageurs Sauveteurs (MNS) indépendants.

2. Rôle de la plateforme

MySwimmingLessons agit en tant qu'intermédiaire technique de mise en relation.
La plateforme n'est pas partie au contrat conclu entre le client et le MNS.

3. Inscription

L'utilisateur s'engage à fournir des informations exactes.
Le compte est personnel et ne peut être cédé.
Chaque utilisateur est seul responsable des informations qu'il publie sur la plateforme ainsi que de l'utilisation qu'il fait des services proposés.

4. Géolocalisation

L'utilisateur peut autoriser la géolocalisation afin d'afficher les MNS ou piscines à proximité.
Cette fonctionnalité est facultative.

5. Obligations des utilisateurs

L'utilisateur s'engage à :
• utiliser la plateforme de manière loyale
• ne pas porter atteinte aux droits des autres utilisateurs
• respecter la réglementation en vigueur

6. Engagements du MNS

Le MNS s'engage à maintenir en vigueur l'ensemble des diplômes, qualifications et assurances nécessaires à l'exercice de son activité pendant toute la durée d'utilisation de la plateforme.

MySwimmingLessons ne procède à aucun contrôle continu des diplômes, qualifications ou autorisations professionnelles des MNS après leur validation initiale.

7. Lieux de pratique référencés par les utilisateurs

Les utilisateurs peuvent proposer ou référencer des lieux de pratique (piscines privées ou publiques). Ces informations sont fournies sous la responsabilité exclusive de l'utilisateur qui les publie. MySwimmingLessons ne vérifie pas systématiquement la conformité, la sécurité ou les conditions sanitaires des lieux proposés.

L'utilisateur qui propose un lieu de pratique s'engage à s'assurer que celui-ci est adapté, sécurisé et conforme aux règles d'hygiène et de sécurité applicables.

8. Signalement et modération

Tout utilisateur peut signaler un lieu, un contenu ou un comportement jugé dangereux ou non conforme depuis les fiches utilisateur ou établissement de la plateforme.

MySwimmingLessons se réserve le droit de retirer ou désactiver tout contenu signalé après analyse.

9. Responsabilité

MySwimmingLessons ne garantit pas :
• la qualité des prestations réalisées par les MNS
• la disponibilité des MNS

Le MNS est seul responsable de la prestation fournie.

10. Suspension / résiliation

MySwimmingLessons se réserve le droit de suspendre ou supprimer tout compte MNS ou utilisateur en cas de :
• signalement étayé
• perte de qualification
• comportement dangereux
• fraude ou non-respect des présentes CGU.

11. Exécution personnelle des prestations (interdiction de sous-traitance)

Le MNS titulaire du compte s'engage à réaliser personnellement l'intégralité des prestations qu'il publie sur la plateforme. Toute substitution, délégation, sous-traitance ou prêt de compte à un tiers est strictement interdite et constitue un motif de résiliation immédiate du compte, sans préavis ni remboursement de l'abonnement en cours.

Les documents (diplômes, carte professionnelle, attestation d'assurance, attestation URSSAF, photo d'identité) sont strictement personnels et ne peuvent en aucun cas être partagés, prêtés ou transmis. Toute utilisation des documents d'autrui entraîne la suspension immédiate et définitive du compte ainsi que, le cas échéant, un signalement aux autorités compétentes.

12. Lutte contre le travail dissimulé

Le MNS garantit MySwimmingLessons contre tout recours fondé sur l'emploi de travailleurs non déclarés, conformément aux articles L.8221-1 et suivants du Code du travail. Le MNS s'engage à fournir, sur simple demande de l'administrateur, son attestation de vigilance URSSAF en cours de validité (renouvelée tous les 6 mois).

13. Obligations fiscales et déclaratives

Le MNS reconnaît être seul responsable de la déclaration de l'ensemble des revenus perçus via la plateforme aux administrations fiscales et sociales compétentes (URSSAF, impôts, RSI/SSI, etc.). MySwimmingLessons fournit chaque année un récapitulatif des sommes encaissées via Stripe Connect Express ; ce document a uniquement valeur informative et ne dispense pas le MNS de ses obligations déclaratives.

Le MNS s'engage en outre à informer sans délai la plateforme de toute évolution de sa situation administrative pouvant affecter la légalité de l'exercice de son activité (perte de carte professionnelle, péremption d'un diplôme, cessation d'activité, déménagement, etc.). À défaut, MySwimmingLessons décline toute responsabilité en cas de litige.

14. Champ d'application territorial

Les présentes CGU et l'ensemble des services proposés par MySwimmingLessons sont strictement limités à la France métropolitaine. Toute utilisation de la plateforme en dehors de ce périmètre (DROM-COM, étranger) est faite sous la seule responsabilité de l'utilisateur, MySwimmingLessons ne pouvant garantir ni la conformité réglementaire ni la couverture assurantielle dans ces zones.`;

export const CGV_TEXT = `Préambule — Définition

Dans les présentes CGV, "MNS" désigne le Maître-Nageur Sauveteur, professionnel diplômé exerçant l'enseignement et la surveillance de la natation.

1. Objet

Les présentes CGV définissent les conditions de réservation et de paiement des prestations proposées par les Maîtres-Nageurs Sauveteurs (MNS) via la plateforme MySwimmingLessons.

MySwimmingLessons agit en qualité d'intermédiaire technique mettant en relation des clients et des Maîtres-Nageurs Sauveteurs (MNS). La plateforme n'est pas partie au contrat de prestation de service conclu entre le client et le MNS.

2. Vérification des qualifications des MNS

MySwimmingLessons procède à une vérification des diplômes et qualifications des MNS lors de leur inscription sur la plateforme. Cette vérification est effectuée uniquement à l'entrée et ne constitue pas une obligation de contrôle continu.

Le MNS s'engage à maintenir en vigueur ses diplômes, qualifications et assurances pendant toute la durée d'utilisation de la plateforme.

3. Formation du contrat

Le contrat de prestation est conclu directement entre le client et le MNS lors de la validation de la réservation.
MySwimmingLessons agit uniquement en tant qu'intermédiaire technique et n'est pas partie au contrat.

4. Prix et frais de service

Les prix des prestations sont librement fixés par les MNS.
MySwimmingLessons applique des frais de service exprimés en pourcentage du prix du cours, clairement indiqués au moment de la réservation.

Le prix total payé par le client comprend :
• le prix du cours (revenant au MNS)
• les frais de service (revenant à MySwimmingLessons)

⚠️ Les frais d'accès aux infrastructures sportives (piscines, centres aquatiques ou installations privées) ne sont pas inclus dans le prix du cours et restent à la charge du client lorsqu'applicable. MySwimmingLessons n'est pas responsable des conditions d'accès ou de fonctionnement de ces infrastructures.

5. Paiement

Le paiement est effectué en ligne via un prestataire sécurisé tel que Stripe Connect.
Les fonds sont répartis automatiquement entre le MNS et MySwimmingLessons.

6. Facturation

Le MNS est responsable de l'émission de la facture correspondant à la prestation.
MySwimmingLessons émet une facture distincte correspondant aux frais de service.

7. Droit de rétractation

Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux prestations de services de loisirs fournies à une date ou selon une périodicité déterminée. La réservation d'un créneau de cours de natation est donc ferme et définitive dès sa validation.

8. Annulation

Toute annulation effectuée par le client moins de 24 heures avant le début du cours entraîne la facturation de 30 % du prix du cours.
Les conditions spécifiques d'annulation peuvent être précisées par le MNS et sont affichées avant la réservation.

En cas d'annulation par le MNS, le client est intégralement remboursé.

En cas d'impossibilité de réalisation de la prestation pour cause de force majeure, aucune pénalité ne pourra être appliquée.

9. Responsabilité de la plateforme

Le MNS est seul responsable de la qualité, de la sécurité et de la conformité de la prestation qu'il réalise.

MySwimmingLessons ne saurait être tenue responsable de l'exécution des prestations réalisées par les MNS, des annulations de cours, ni des conditions d'utilisation des infrastructures sportives, sauf en cas de faute directement imputable au fonctionnement de la plateforme.

10. Engagements du MNS

Le MNS certifie être titulaire des diplômes requis pour l'encadrement de la natation et disposer d'une assurance responsabilité civile professionnelle en cours de validité.

Il s'engage à exercer son activité dans le respect de la réglementation en vigueur.

11. Engagements du client

Le client déclare être apte à la pratique de la natation et ne présenter aucune contre-indication médicale.

Il s'engage à respecter les consignes de sécurité données par le MNS et les règles de l'établissement d'accueil.

12. Abonnement professionnel MNS

Pour publier des créneaux visibles par les clients, les Maîtres-Nageurs Sauveteurs (MNS) doivent souscrire à l'un des abonnements suivants :

• Formule Mensuelle : 9,99 € TTC / mois, sans engagement, résiliable à tout moment (effet à la fin de la période de facturation en cours).

• Formule Annuelle : 119,88 € TTC / an. La première année comprend 14 mois :
   – Les 2 premiers mois sont offerts (période d'essai gratuite).
   – À l'issue de ces 2 mois, le MNS est automatiquement prélevé de 119,88 € TTC.
   – Le renouvellement annuel (12 mois) s'effectue ensuite à la date anniversaire, soit 14 mois après la souscription initiale.

Un email de rappel est envoyé avant chaque renouvellement automatique de l'abonnement.

Le MNS peut résilier son abonnement à tout moment depuis son espace personnel (Profil > Abonnement). La résiliation prend effet à la fin de la période de facturation en cours : aucun remboursement prorata temporis n'est effectué pour la période non consommée.

En l'absence d'abonnement actif, le MNS peut créer et gérer ses créneaux, mais ces derniers ne sont pas visibles par les clients (ni sur la carte, ni sur la recherche, ni sur la fiche publique), et aucune réservation n'est possible.

En cas d'échec de paiement, l'abonnement bascule automatiquement en statut "past_due" puis "canceled" après plusieurs tentatives infructueuses, conformément à la politique de Stripe. Le MNS est notifié par email.

13. Suspension / suppression de compte

L'utilisateur est responsable des informations fournies lors de son inscription.
MySwimmingLessons se réserve le droit de suspendre ou supprimer un compte en cas de fraude, comportement abusif ou non-respect des présentes CGV.

14. Force majeure

Aucune des parties ne pourra être tenue responsable en cas de non-exécution due à un événement de force majeure au sens du droit français.

15. Données personnelles

Les données personnelles collectées sont nécessaires à la gestion des réservations et des paiements.

Pour en savoir plus sur la gestion de ses données et ses droits, l'utilisateur est invité à consulter la Politique de confidentialité disponible sur https://www.myswimminglessons.fr/legal/privacy (ou via le pied de page du site).

16. Litiges

En cas de litige, une solution amiable sera recherchée en priorité.
À défaut, le consommateur peut saisir le tribunal compétent conformément aux dispositions du Code de la consommation.

17. Droit applicable

Les présentes CGV sont soumises au droit français.

18. Frais de service — caractère non remboursable

Les frais de service de la plateforme (commission de 10 % du montant de la prestation TTC) sont prélevés au moment du paiement de la réservation. Ces frais rémunèrent la mise en relation, la sécurisation des paiements, la facturation conforme et l'assistance fournie par MySwimmingLessons.

Conformément à l'article L.221-28 du Code de la consommation et à l'usage en vigueur sur les plateformes de mise en relation, les frais de service sont **non remboursables**, y compris en cas d'annulation d'une réservation par le client ou par le MNS, quelle qu'en soit la raison.

Une seule exception : en cas de défaillance technique avérée de la plateforme empêchant la réalisation de la prestation (indisponibilité prolongée, bug bloquant, échec d'agrégation des paiements imputable à MySwimmingLessons), les frais de service peuvent être remboursés au client sur demande écrite à contact@myswimminglessons.fr, après instruction par notre service support. Aucun remboursement de frais ne sera accordé en cas d'absence du MNS, d'absence du client, de mauvais temps, ou de tout autre événement extérieur à la plateforme.

19. Champ d'application territorial

Les présentes CGV s'appliquent exclusivement aux prestations réalisées en France métropolitaine.`;

export const PRIVACY_TEXT = `1. Responsable du traitement

Le responsable du traitement est SAS ALEX SWIM COACH (éditrice de MySwimmingLessons), dont le siège social est situé 11 allée des acacias, 92310 SÈVRES (France).
Pour toute question relative au traitement de vos données personnelles, vous pouvez nous contacter à : contact@myswimminglessons.fr.

Les données sont hébergées en France chez OVH SAS (2 rue Kellermann, 59100 Roubaix), dans l'Union européenne.

2. Données collectées

MySwimmingLessons collecte les données suivantes :

Données d'identification
• nom, prénom
• adresse email
• numéro de téléphone

Données de compte
• identifiants de connexion
• historique de réservation

Données de paiement
Les paiements sont traités par un prestataire tiers (ex : Stripe).
MySwimmingLessons ne stocke pas les données bancaires.

Données de géolocalisation
Uniquement avec le consentement de l'utilisateur, pour proposer des services à proximité.

3. Finalités du traitement

Les données sont utilisées pour :
• gérer les comptes utilisateurs
• permettre la mise en relation entre clients et coachs
• gérer les réservations et paiements
• améliorer le service
• envoyer des communications (si consentement)

4. Base légale

Les traitements reposent sur :
• l'exécution du contrat (réservation de cours)
• le consentement (marketing, géolocalisation)
• l'obligation légale (facturation)

Conformément au Règlement général sur la protection des données.

5. Destinataires des données

Les données peuvent être transmises :
• aux coachs (dans le cadre des réservations)
• aux prestataires techniques (paiement, hébergement)
• aux autorités si obligation légale

6. Durée de conservation

Les données sont conservées :
• pendant la durée du compte
• puis archivées selon les obligations légales (notamment fiscales)

7. Droits des utilisateurs

L'utilisateur dispose des droits suivants :
• accès
• rectification
• suppression
• limitation
• portabilité

Pour exercer ces droits : contacter le support MySwimmingLessons.

8. Sécurité

MySwimmingLessons met en œuvre des mesures techniques et organisationnelles pour protéger les données.

9. Cookies

Des cookies peuvent être utilisés pour :
• le fonctionnement du site
• les statistiques

Le consentement est demandé lorsque nécessaire.

10. Modification

MySwimmingLessons se réserve le droit de modifier la présente politique à tout moment.`;

export const MENTIONS_TEXT = `1. Éditeur de la plateforme

La plateforme MySwimmingLessons, accessible à l'adresse https://www.myswimminglessons.fr, est éditée par :
• Dénomination sociale : SAS ALEX SWIM COACH
• Forme juridique : SAS
• Siège social : 11 allée des acacias, 92310 SÈVRES
• SIRET : 98785940200016
• RCS : NANTERRE
• Numéro de TVA intracommunautaire : FR74987859402
• Email de contact : contact@myswimminglessons.fr

2. Hébergement

Le site est hébergé par :
• Hébergeur : OVH SAS
• Adresse : 2 rue Kellermann, 59100 Roubaix, France
• Téléphone : +33 9 72 10 10 07
• Site web : https://www.ovhcloud.com

Les données sont hébergées en France, conformément au Règlement général sur la protection des données (RGPD).

3. Activité de la plateforme

MySwimmingLessons est une plateforme de mise en relation entre clients et Maîtres-Nageurs Sauveteurs (MNS) indépendants.
MySwimmingLessons agit uniquement en tant qu'intermédiaire technique et n'est pas partie au contrat conclu entre le client et le MNS.

4. Propriété intellectuelle

L'ensemble des éléments présents sur la plateforme (textes, images, logo, interface) est protégé par le droit de la propriété intellectuelle.
Toute reproduction ou utilisation non autorisée est interdite.

5. Données personnelles

Les données personnelles sont traitées conformément au Règlement général sur la protection des données.
Pour plus d'informations, consulter la Politique de confidentialité sur https://www.myswimminglessons.fr/legal/privacy.

6. Responsabilité

MySwimmingLessons ne saurait être tenu responsable :
• de la qualité des prestations réalisées par les MNS
• des dommages survenus lors des prestations
• des conditions d'accès aux infrastructures sportives

7. Contact

Pour toute question : contact@myswimminglessons.fr`;
